/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayForwardIcon20Solid = forwardRef('MediaUiAPlayForwardIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m9.606 3.14 8.61 5.421a1.7 1.7 0 0 1 0 2.877l-8.61 5.421C8.474 17.572 7 16.76 7 15.421V4.579c0-1.338 1.474-2.151 2.606-1.438Z" }),
        React.createElement("path", { d: "M5 4a1 1 0 1 0-2 0v12a1 1 0 1 0 2 0V4Z" })));
});
